import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BookmarkActions } from "../../services/Redux/BookmarkReducer";
import Global from "../../services/Common/Global";
import Commons from "../../services/Common/Common";
import IndexedDb from "../../services/IndexedDb/IndexedDb";
import { Loading, Button, Dropdown, ButtonGroup, Dialog, Radio, Checkbox } from "../../Components/Bootstrap";
import { Stack, Card, ToggleButton } from "react-bootstrap";
import Terms from "../Login/Terms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faRotateRight } from "@fortawesome/free-solid-svg-icons";

function AdminAutoDispatch() {
  // Redux
  const dispatch = useDispatch();
  const bookmarkStates = useSelector((state) => state.Bookmarks);

  // States
  const [loading, setLoading] = useState(false);
  const [reloadTime, setReloadTime] = useState(Commons.Storages("get", "saves").reloadTime);
  const [userInfo, setUserInfo] = useState("");
  const [busList, setBusList] = useState([]);
  const [selectedBusTitle, setSelectedBusTitle] = useState("버스를 선택하세요.");
  const [selectBusValue, setSelectBusValue] = useState("");
  const [autoDispatchList, setAutoDispatchList] = useState([]);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [termsToggle, setTermsToggle] = useState(false); // 약관 동의 토글
  const [termsChecked, setTermsChecked] = useState(false); // 약관 동의 체크
  // 배차 수정 관련 states
  const [modifyToggle, setModifyToggle] = useState(false);
  const [modifyCarList, setModifyCarList] = useState([]);
  const [modifyHolidayList, setModifyHolidayList] = useState([]);
  const [modifyWorkList, setModifyWorkList] = useState([]);
  const [modifyInputs, setModifyInputs] = useState({
    selectedCar: "",
    holidayPeopleValue: "",
    workPeopleValue: "",
    radioValue: "",
    hour: "00",
    minute: "00",
    inOutToggle: false,
  });

  // 즉시 출발 관련 states
  const [rightNowToggle, setRightNowToggle] = useState(false);

  // 회차 변경 관련 states
  const [changeRouteToggle, setChangeRouteToggle] = useState(false);
  const [changeRouteInputs, setChangeRouteInputs] = useState({
    selectedBeforeItem: {},
    selectedAfterItem: {},
  });
  const [changeRouteSelectedIndexes, setChangeRouteSelectedIndexes] = useState([]);
  const [changeRouteToggle1, setChangeRouteToggle1] = useState(false);

  // 결행 관련 states
  const [executionToggle, setExecutionToggle] = useState(false);
  const [executionRadio, setExecutionRadio] = useState("");

  // 사고 고장 관련 states
  const [accidentToggle, setAccidentToggle] = useState(false);
  const [accidentCarList, setAccidentCarList] = useState([]);
  const [accidentStationList, setAccidentStationList] = useState([]);
  const [accidentInputs, setAccidentInputs] = useState({
    selectedCardIndex: "",
    accidentRadioValue: "",
    stationValue: "",
    changedCarRadioValue: "Y",
    changedCarValue: "",
    holidayPeopleValue: "",
    workPeopleValue: "",
    episodeRadioValue: "",
  });
  const [accidentToggle1, setAccidentToggle1] = useState(false);
  const [accidentChangeCarList, setAccidentChangeCarList] = useState([]);
  const [accidentHolidayPeopleList, setAccidentHolidayPeopleList] = useState([]);
  const [accidentWorkPeopleList, setAccidentWorkPeopleList] = useState([]);
  const [accidentToggle2, setAccidentToggle2] = useState(false);
  const [accidentConfirmItem, setAccidentConfirmItem] = useState({});

  // Effects
  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    const Interval = setInterval(() => {
      if (!reloadTime || reloadTime == "00") return;
      if (selectBusValue) SelectLogic1(selectBusValue);
    }, Number(reloadTime) * 1000);

    return () => clearInterval(Interval);
  }, [selectBusValue]);

  // 초기화
  const Init = async () => {
    try {
      let userData = null;
      await IndexedDb.GetLoginInfo().then((result) => {
        userData = result;
        setUserInfo(result);
      });
      console.log("userData: ", userData);
      if (!userData.infoYn || userData.infoYn == "N") {
        setTermsToggle(true);
        return;
      }
      await SelectLogic();
      if (bookmarkStates.bookmarks) {
        setSelectedBusTitle(bookmarkStates.busNo);
        setSelectBusValue(bookmarkStates.routeId);
        SelectLogic1(bookmarkStates.routeId);
      } else {
        setSelectedBusTitle("버스를 선택해주세요.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // API 호출 함수들
  const SelectLogic = async () => {
    setLoading(true);
    let _busList = [];

    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "route",
        key1: "",
        key2: "",
        key3: "",
        key4: "",
      });

      const data = result.data;

      if (data.type == "Error") {
        throw new Error(data.message);
      } else if (data.length > 0) {
        setBusList(data);
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 버스 배차 조회
  const SelectLogic1 = async (_param1) => {
    setLoading(true);

    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.AdminAutoDispatch.AdminAutoDispatch, { routeId: _param1 });

      const data = result.data;
      console.log("SelectLogic1: ", data);

      if (data.type == "Error") {
        throw new Error(data.message);
      } else if (data === "데이터가 없습니다.") {
        throw new Error(data);
      } else if (data.length > 0) {
        setAutoDispatchList(data);
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 대차 콤보 리스트 조회
  const SelectLogic2 = async () => {
    setLoading(true);

    try {
      if (!selectBusValue) {
        throw new Error("노선을 선택해주세요.");
      }

      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "VEHICLE",
        key1: selectBusValue,
        key2: "",
        key3: "",
        key4: "",
      });

      const data = result.data;

      if (data.type == "Error") {
        throw new Error(data.message);
      } else if (data === "데이터가 없습니다.") {
        throw new Error(data);
      } else if (data.length > 0) {
        setModifyCarList(data);
        setAccidentChangeCarList(data);
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 휴무자 콤보 리스트 조회
  const SelectLogic3 = async () => {
    setLoading(true);

    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.AccidentCar.GetDriver, { workyn: "N" });

      const data = result.data;
      console.log("SelectLogic3: ", data);

      if (data.type == "Error") {
        throw new Error(data.message);
      } else if (data === "데이터가 없습니다.") {
        throw new Error(data);
      } else if (data.id) {
        const parsed = JSON.parse(data.result);
        console.log("SelectLogic3 parsed: ", parsed);
        setModifyHolidayList(parsed);
        setAccidentHolidayPeopleList(parsed);
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 근무자 콤보 리스트 조회
  const SelectLogic4 = async () => {
    setLoading(true);

    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.AccidentCar.GetDriver, { workyn: "Y" });

      const data = result.data;
      console.log("SelectLogic4: ", data);

      if (data.type == "Error") {
        throw new Error(data.message);
      } else if (data === "데이터가 없습니다.") {
        throw new Error(data);
      } else if (data.result.length > 0) {
        const parsed = JSON.parse(data.result);
        console.log("SelectLogic4 parsed: ", parsed);
        setModifyWorkList(parsed);
        setAccidentWorkPeopleList(parsed);
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 운행 중 배차 시간표 조회
  const SelectLogic5 = async () => {
    setLoading(true);

    try {
      if (!selectBusValue) {
        throw new Error("버스를 선택해주세요.");
      }

      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.AccidentCar.GetPlan, { routeId: selectBusValue });

      const data = result.data;

      if (data.type == "Error") {
        throw new Error(data.message);
      } else if (data === "데이터가 없습니다.") {
        throw new Error(data);
      } else if (data.length > 0) {
        setAccidentCarList(data);
        await SelectLogic6();
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 정류장 콤보 조회
  const SelectLogic6 = async () => {
    setLoading(true);

    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Common.GetCode, {
        code: "STATION",
        key1: selectBusValue,
        key2: "",
        key3: "",
        key4: "",
      });

      const data = result.data;

      if (data.type == "Error") {
        throw new Error(data.message);
      } else if (data === "데이터가 없습니다.") {
        throw new Error(data);
      } else if (data.length > 0) {
        setAccidentStationList(data);
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 배차 수정
  const SaveLogic = async () => {
    setLoading(true);

    try {
      if (!modifyInputs.selectedCar) {
        throw new Error("변경할 대차를 선택하세요.");
      }
      // else if (
      //   !modifyInputs.holidayPeopleValue &&
      //   !modifyInputs.workPeopleValue
      // ) {
      //   throw new Error("휴무자 또는 근로자를 선택하세요.");
      // }
      else if (!modifyInputs.radioValue) {
        throw new Error("적용 회차를 선택하세요.");
      }

      const result = await Commons.Axios("post", Global.base.useUrl + Global.urls.AdminAutoDispatch.Create, {
        newOpratIdx: 0,
        hh: autoDispatchList[selectedCardIndex].hh,
        mm: autoDispatchList[selectedCardIndex].mm,
        newHh: modifyInputs.hour,
        newMm: modifyInputs.minute,
        opratDt: autoDispatchList[selectedCardIndex].opratDt,
        routeId: selectBusValue,
        opratExchngYn: autoDispatchList[selectedCardIndex].opratExchngYn,
        opratIdx: autoDispatchList[selectedCardIndex].opratIdx,
        carId: autoDispatchList[selectedCardIndex].vhcleId,
        newCarId: modifyInputs.selectedCar,
        driverId: autoDispatchList[selectedCardIndex].driverId,
        newDriverId: modifyInputs.holidayPeopleValue ? modifyInputs.holidayPeopleValue : modifyInputs.workPeopleValue ? modifyInputs.workPeopleValue : autoDispatchList[selectedCardIndex].driverId,
        // newDriverId:
        //   modifyInputs.holidayPeopleValue || modifyInputs.workPeopleValue,
        amPmDiv: modifyInputs.radioValue,
        driveOut: modifyInputs.inOutToggle ? "Y" : "N",
      });

      const data = result.data;

      if (data.type === "Error") {
        throw new Error(data.message);
      } else if (data === "Already Exists Tag") {
        throw new Error("이미 등록된 Tag 입니다.");
      } else if (data === "Ok") {
        setModifyToggle(false);
        SelectLogic1(selectBusValue);
        SelectLogic2();
        SelectLogic3();
        SelectLogic4();
        setSelectedCardIndex("");
        setModifyInputs({
          ...modifyInputs,
          hour: "00",
          minute: "00",
          radioValue: "",
          selectedCar: "",
          holidayPeopleValue: "",
          workPeopleValue: "",
        });
        Commons.Toast("success", "수정되었습니다.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 즉시 출발
  const SaveLogic1 = async (_param) => {
    setLoading(true);

    try {
      if (!selectBusValue) {
        throw new Error("버스를 선택해주세요.");
      } else if (!selectedCardIndex && selectedCardIndex !== 0) {
        throw new Error("수정할 회차를 선택해주세요.");
      }

      const result = await Commons.Axios("post", Global.base.useUrl + Global.urls.AdminAutoDispatch.Start, _param);

      const data = result.data;

      if (data.type === "Error") {
        throw new Error(data.message);
      } else if (data === "Ok") {
        setRightNowToggle(false);
        SelectLogic1(selectBusValue);
        setSelectedCardIndex("");
        Commons.Toast("success", "적용되었습니다.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 회차 변경
  const SaveLogic2 = async (_param) => {
    setLoading(true);

    try {
      const result = await Commons.Axios("post", Global.base.useUrl + Global.urls.AdminAutoDispatch.ChangeIdx, {
        ..._param,
        amPmDiv: "",
        carId: _param.vhcleId,
        newOpratIdx: autoDispatchList[changeRouteSelectedIndexes[1]].opratIdx,
        newCarId: "",
        newDriverId: "",
        newHh: "",
        newMm: "",
      });

      const data = result.data;

      if (data.type === "Error") {
        throw new Error(data.message);
      } else if (data === "Ok") {
        setChangeRouteToggle1(false);
        setChangeRouteToggle(false);
        setChangeRouteSelectedIndexes([]);
        SelectLogic1(selectBusValue);
        setSelectedCardIndex("");
        Commons.Toast("success", "변경되었습니다.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 결행 처리
  const SaveLogic3 = async (_param) => {
    setLoading(true);

    try {
      if (!executionRadio) {
        throw new Error("적용 항목을 선택해주세요.");
      }

      const result = await Commons.Axios("post", Global.base.useUrl + Global.urls.AdminAutoDispatch.Execute, {
        ..._param,
        newOpratIdx: 0,
        carId: "",
        newCarId: "",
        newDriverId: "",
        amPmDiv: executionRadio,
        newHh: "",
        newMm: "",
      });

      const data = result.data;

      if (data.type === "Error") {
        throw new Error(data.message);
      } else if (data === "Ok") {
        setExecutionRadio("");
        setExecutionToggle(false);
        SelectLogic1(selectBusValue);
        setSelectedCardIndex("");
        Commons.Toast("success", "처리되었습니다.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 사고 고장 처리
  const SaveLogic4 = async () => {
    setLoading(true);

    try {
      if (accidentInputs.changedCarRadioValue == "Y" && !accidentInputs.changedCarRadioValue) {
        throw new Error("대차 처리를 선택해주세요.");
      } else if (accidentInputs.changedCarRadioValue == "Y" && !accidentInputs.changedCarValue) {
        throw new Error("변경 차량을 선택해주세요.");
      }
      // else if (
      //   accidentInputs.changedCarRadioValue == "Y" &&
      //   !accidentInputs.holidayPeopleValue &&
      //   !accidentInputs.workPeopleValue
      // ) {
      //   throw new Error("변경할 승무원을 선택해주세요.");
      // }
      else if (accidentInputs.changedCarRadioValue == "Y" && !accidentInputs.episodeRadioValue) {
        throw new Error("적용회차를 선택해주세요.");
      }

      const result = await Commons.Axios("post", Global.base.useUrl + Global.urls.AccidentCar.Create, {
        opratDt: accidentCarList[accidentInputs.selectedCardIndex].opratDt,
        routeId: selectBusValue,
        opratExchngYn: accidentCarList[accidentInputs.selectedCardIndex].opratExchngYn,
        opratIdx: accidentCarList[accidentInputs.selectedCardIndex].opratIdx,
        carId: accidentCarList[accidentInputs.selectedCardIndex].vhcleId,
        newCarId: accidentInputs.changedCarValue,
        driverId: accidentCarList[accidentInputs.selectedCardIndex].driverId,
        newDriverId: accidentInputs.holidayPeopleValue ? accidentInputs.holidayPeopleValue : accidentInputs.workPeopleValue ? accidentInputs.workPeopleValue : "",
        // newDriverId:
        //   accidentInputs.holidayPeopleValue || accidentInputs.workPeopleValue,
        amPmDiv: accidentInputs.episodeRadioValue,
        accidentFlag: accidentInputs.accidentRadioValue,
        changeCarFlag: accidentInputs.changedCarRadioValue,
        stationIdx: accidentInputs.stationValue,
      });

      const data = result.data;
      console.log("사고 고장 처리: ", data);

      if (data.type === "Error") {
        throw new Error(data.message);
      } else if (data === "Not Data") {
        AccidentClosed(1);
        SelectLogic5();
        throw new Error("Not Data | 저장 실패");
      } else if (data === "Ok") {
        AccidentClosed(1);
        SelectLogic2();
        SelectLogic3();
        SelectLogic4();
        SelectLogic5();
        Commons.Toast("success", "처리되었습니다.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 사고/고장 승인
  const SaveLogic5 = async (_param) => {
    setLoading(true);

    try {
      const result = await Commons.Axios("post", Global.base.useUrl + Global.urls.AccidentCar.Complete, _param);

      const data = result.data;

      if (data.type === "Error") {
        throw new Error(data.message);
      } else if (data === "Not Data") {
        throw new Error("데이터가 없습니다.");
      } else if (data === "Ok") {
        AccidentClosed(1);
        setAccidentToggle2(false);
        SelectLogic1(selectBusValue);
        SelectLogic2();
        SelectLogic3();
        SelectLogic4();
        SelectLogic5();
        Commons.Toast("success", "승인 되었습니다.");
      }
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    } finally {
      setLoading(false);
    }
  };

  // 약관 동의
  const ApplyLogic = async () => {
    try {
      await Commons.Axios("post", Global.base.useUrl + Global.urls.Apply, {
        termsChecked: termsChecked,
      }).then((result) => {
        let data = result.data;
        console.log("약관 동의 결과: ", data);

        if (data === "Ok") {
          IndexedDb.UpdateDb("LoginInfo", userInfo.token, {
            ...userInfo,
            infoYn: "Y",
          });
          setTermsToggle(false);
        } else {
          throw new Error(data);
        }
      });
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 배차 수정 벨리데이션
  const ModifyValidation = async () => {
    try {
      if (!selectBusValue) {
        throw new Error("버스를 선택해주세요.");
      } else if (!selectedCardIndex && selectedCardIndex !== 0) {
        throw new Error("수정할 회차를 선택해주세요.");
      }

      await SelectLogic2();
      await SelectLogic3();
      await SelectLogic4();

      setModifyInputs({
        ...modifyInputs,
        hour: autoDispatchList[selectedCardIndex].hh,
        minute: autoDispatchList[selectedCardIndex].mm,
      });
      setModifyToggle(true);
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  // 배차 수정 시간 변경 로직
  const IncreaseNumber = (_type) => {
    let _hour = Number(modifyInputs.hour);
    let _minute = Number(modifyInputs.minute);

    if (isNaN(_hour) || isNaN(_minute)) return false;

    switch (_type) {
      case 0:
        if (_hour == 23) return false;
        _hour++;
        return setModifyInputs({
          ...modifyInputs,
          hour: _hour.toString().padStart(2, "0"),
        });
      case 1:
        if (_hour == 0) return false;
        _hour--;
        return setModifyInputs({
          ...modifyInputs,
          hour: _hour.toString().padStart(2, "0"),
        });
      case 2:
        if (_minute == 59) return false;
        _minute++;
        return setModifyInputs({
          ...modifyInputs,
          minute: _minute.toString().padStart(2, "0"),
        });
      case 3:
        if (_minute == 0) return false;
        _minute--;
        return setModifyInputs({
          ...modifyInputs,
          minute: _minute.toString().padStart(2, "0"),
        });
    }
  };

  // 사고 고장 벨리데이션
  const AccidentValidation = async () => {
    try {
      if (!accidentInputs.selectedCardIndex && accidentInputs.selectedCardIndex !== 0) {
        throw new Error("운행 차량을 선택하세요.");
      } else if (!accidentInputs.accidentRadioValue) {
        throw new Error("사고·고장을 선택하세요.");
      } else if (!accidentInputs.stationValue) {
        throw new Error("정류장을 선택하세요.");
      }

      await SelectLogic2();
      await SelectLogic3();
      await SelectLogic4();
      setAccidentToggle1(true);
    } catch (e) {
      console.log("Error: ", e);
      Commons.Toast("error", e.message);
    }
  };

  const AccidentClosed = (_type) => {
    if (_type == 1) {
      setAccidentToggle1(false);
    } else {
      setAccidentToggle1(false);
      setAccidentToggle(false);
    }

    setAccidentInputs({
      selectedCardIndex: "",
      accidentRadioValue: "",
      stationValue: "",
      changedCarRadioValue: "Y",
      changedCarValue: "",
      holidayPeopleValue: "",
      workPeopleValue: "",
      episodeRadioValue: "",
    });

    setAccidentChangeCarList([]);
    setAccidentHolidayPeopleList([]);
    setAccidentStationList([]);
    setAccidentWorkPeopleList([]);
  };

  return (
    <React.Fragment>
      <Card className='mb-2'>
        <Card.Body className='horizontal-card-body'>
          <Dropdown
            className='me-3'
            variant='outline-primary'
            title={selectedBusTitle}
            items={busList}
            value={selectBusValue}
            onChange={(e) => {
              setSelectBusValue(e);
              Commons.Storages("set", "saves", {
                ...Commons.Storages("get", "saves"),
                busNo: busList.filter((f) => f.value == e)[0].text,
                routeId: e,
              });
              setSelectedCardIndex("");
              SelectLogic1(e);
            }}
          />
          <Button
            className='me-3'
            size='sm'
            title={<FontAwesomeIcon icon={faStar} color={bookmarkStates.routeId === selectBusValue ? "#ffc301" : "#ffffff"} />}
            onClick={() => {
              if (selectBusValue === "") return;

              if (selectBusValue !== bookmarkStates.routeId) {
                dispatch(BookmarkActions.setBusNo(busList.filter((f) => f.value == selectBusValue)[0].text));
                dispatch(BookmarkActions.setRouteId(selectBusValue));
                dispatch(BookmarkActions.setBookmarks(true));
              } else if (bookmarkStates.bookmarks || !selectBusValue) {
                dispatch(BookmarkActions.setBusNo("0"));
                dispatch(BookmarkActions.setRouteId("0"));
                dispatch(BookmarkActions.setBookmarks(false));
              } else {
                dispatch(BookmarkActions.setBusNo(busList.filter((f) => f.value == selectBusValue)[0].text));
                dispatch(BookmarkActions.setRouteId(selectBusValue));
                dispatch(BookmarkActions.setBookmarks(true));
              }
            }}
          />
          <Button size='sm' title={<FontAwesomeIcon icon={faRotateRight} onClick={() => SelectLogic1(selectBusValue)} />} />
        </Card.Body>
      </Card>

      <Card>
        <Card.Body className='custom-table-grid-header'>
          <Stack direction='horizontal'>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>회차</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>출발시간</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>차량번호</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-64'>승무원</div>
            <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>비고</div>
          </Stack>
        </Card.Body>
      </Card>

      <div className='custom-table-grid-datas1'>
        {autoDispatchList.map((item, index) => {
          const CheckNumberCar = () => {
            if (index == 0) return "custom-table-grid-datas-first";
            if (index == 1 || index == 2) return "custom-table-grid-datas-next";
            return "";
          };

          const isSelected = index === selectedCardIndex;
          const selectedCardColor = isSelected ? "custom-table-grid-selected" : "";

          return (
            <Card key={index} className={`${CheckNumberCar()} ${selectedCardColor}`} onClick={() => setSelectedCardIndex(index)}>
              <Card.Body className='custom-table-grid-body'>
                <Stack direction='horizontal'>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-48'>{item.opratIdx}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.caralcDtm}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.vhcleNo}</div>
                  <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>{item.name}</div>
                  <div
                    className='p-2 custom-table-grid-body-text custom-table-text-width-48'
                    style={{
                      fontSize: item.remark.length > 2 ? "12px" : "1rem",
                    }}
                  >
                    {item.remark}
                  </div>
                </Stack>
              </Card.Body>
            </Card>
          );
        })}
      </div>

      <ButtonGroup
        className='custom-button-group'
        items={[
          <Button style={{ minWidth: "20%", whiteSpace: "pre-wrap" }} title={`배차\n수정`} onClick={ModifyValidation} />,
          <Button style={{ minWidth: "20%", whiteSpace: "pre-wrap" }} title={`즉시\n출발`} onClick={() => SaveLogic1(autoDispatchList[selectedCardIndex])} />,
          <Button
            style={{ minWidth: "20%", whiteSpace: "pre-wrap" }}
            title={`회차\n변경`}
            onClick={async () => {
              if (!selectBusValue) {
                return Commons.Toast("error", "버스를 선택해주세요.");
              }
              await SelectLogic2();
              await SelectLogic3();
              await SelectLogic4();
              setChangeRouteToggle(true);
            }}
          />,
          <Button
            style={{ minWidth: "20%", whiteSpace: "pre-wrap" }}
            title={`배차\n결행`}
            onClick={() => {
              if (!selectBusValue) {
                return Commons.Toast("error", "버스를 선택해주세요.");
              } else if (!selectedCardIndex && selectedCardIndex !== 0) {
                return Commons.Toast("error", "수정할 회차를 선택해주세요.");
              }
              setExecutionToggle(true);
            }}
          />,
          <Button
            style={{ minWidth: "20%", whiteSpace: "pre-wrap" }}
            title={`사고\n고장`}
            onClick={() => {
              if (!selectBusValue) {
                return Commons.Toast("error", "버스를 선택해주세요.");
              } else {
                SelectLogic5();
                setAccidentToggle(true);
              }
            }}
          />,
        ]}
      />
      {/**
       * .___  ___.   ______    _______   __   _______ ____    ____ 
|   \/   |  /  __  \  |       \ |  | |   ____|\   \  /   / 
|  \  /  | |  |  |  | |  .--.  ||  | |  |__    \   \/   /  
|  |\/|  | |  |  |  | |  |  |  ||  | |   __|    \_    _/   
|  |  |  | |  `--'  | |  '--'  ||  | |  |         |  |     
|__|  |__|  \______/  |_______/ |__| |__|         |__|     
                                                           
       */}
      <Dialog
        title={
          busList.length > 0 && busList.some((f) => f.value == selectBusValue) && autoDispatchList.length > 0 && Number(selectedCardIndex)
            ? `${busList.find((f) => f.value == selectBusValue).text}번 ${autoDispatchList[selectedCardIndex].opratIdx}회차`
            : ""
        }
        show={modifyToggle}
        onHide={() => setModifyToggle(false)}
        onClose={() =>
          setModifyInputs({
            ...modifyInputs,
            carList: [],
            selectedCar: "",
            holidayPeopleList: [],
            holidayPeopleValue: "",
            workPeopleList: [],
            workPeopleValue: "",
            radioValue: "",
            hour: "00",
            minute: "00",
            inOutToggle: false,
          })
        }
        sumitButtonName='확인'
        onSumit={SaveLogic}
      >
        <Stack>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>배차 차량 변경</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>현재차량</span>
            <span>{autoDispatchList.length > 0 && Number(selectedCardIndex) ? autoDispatchList[selectedCardIndex].vhcleNo : ""}</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>대차</span>
            <Dropdown
              variant='outline-primary'
              title={"대차를 선택하세요."}
              items={modifyCarList}
              value={modifyInputs.selectedCar}
              onChange={(e) =>
                setModifyInputs({
                  ...modifyInputs,
                  selectedCar: e,
                })
              }
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>승무원 변경</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>현재</span>
            <span>{autoDispatchList.length > 0 && Number(selectedCardIndex) ? autoDispatchList[selectedCardIndex].name : ""}</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>휴무자</span>
            <Dropdown
              variant='outline-primary'
              title={"휴무자를 선택하세요."}
              items={modifyHolidayList}
              value={modifyInputs.holidayPeopleValue}
              onChange={(e) => {
                setModifyInputs({
                  ...modifyInputs,
                  holidayPeopleValue: e,
                  workPeopleValue: "",
                });
                if (modifyInputs.workPeopleValue) {
                  SelectLogic4();
                }
              }}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>근무자</span>
            <Dropdown
              variant='outline-primary'
              title={"근무자를 선택하세요."}
              items={modifyWorkList}
              value={modifyInputs.workPeopleValue}
              onChange={(e) => {
                setModifyInputs({
                  ...modifyInputs,
                  holidayPeopleValue: "",
                  workPeopleValue: e,
                });
                if (modifyInputs.holidayPeopleValue) {
                  SelectLogic3();
                }
              }}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>적용 회차</span>
          </div>
          <Radio
            items={[
              { value: "2", text: "금회" },
              { value: "0", text: "오전" },
              { value: "1", text: "오후" },
              { value: "3", text: "금일" },
            ]}
            value={modifyInputs.radioValue}
            onChange={(e) =>
              setModifyInputs({
                ...modifyInputs,
                radioValue: e,
              })
            }
          />
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>배차 시간 변경</span>
          </div>
          <div className='custom-dialog-increase'>
            <div className='custom-increase-container'>
              <Button title='+' onClick={() => IncreaseNumber(0)} />
              <span className='custom-increase-Number'>{modifyInputs.hour}</span>
              <Button title='-' onClick={() => IncreaseNumber(1)} />
            </div>
            <span>:</span>
            <div className='custom-increase-container'>
              <Button title='+' onClick={() => IncreaseNumber(2)} />
              <span className='custom-increase-Number'>{modifyInputs.minute}</span>
              <Button title='-' onClick={() => IncreaseNumber(3)} />
            </div>
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>입·출차 관리</span>
          </div>
          <ToggleButton
            className='mb-2'
            id='toggle-check'
            type='checkbox'
            variant='outline-primary'
            disabled={autoDispatchList.length > 0 && Number(selectedCardIndex) && autoDispatchList[selectedCardIndex].remark == "지연" ? false : true}
            checked={modifyInputs.inOutToggle}
            onChange={(e) =>
              setModifyInputs({
                ...modifyInputs,
                inOutToggle: e.currentTarget.checked,
              })
            }
          >
            출차 처리
          </ToggleButton>
        </Stack>
      </Dialog>
      {/**
       * .______       __    _______  __    __  .___________.   .__   __.   ______   ____    __    ____ 
|   _  \     |  |  /  _____||  |  |  | |           |   |  \ |  |  /  __  \  \   \  /  \  /   / 
|  |_)  |    |  | |  |  __  |  |__|  | `---|  |----`   |   \|  | |  |  |  |  \   \/    \/   /  
|      /     |  | |  | |_ | |   __   |     |  |        |  . `  | |  |  |  |   \            /   
|  |\  \----.|  | |  |__| | |  |  |  |     |  |        |  |\   | |  `--'  |    \    /\    /    
| _| `._____||__|  \______| |__|  |__|     |__|        |__| \__|  \______/      \__/  \__/     
                                                                                               
       */}
      <Dialog header={false} show={rightNowToggle} onHide={() => setRightNowToggle(false)} sumitButtonName='확인' onSumit={() => {}}>
        <Stack className='mt-3'>
          <p>즉시 출발 적용 하시겠습니까?</p>
          <p>
            {busList.length > 0 && busList.some((f) => f.value == selectBusValue) && autoDispatchList.length > 0 && Number(selectedCardIndex)
              ? `(${busList.find((f) => f.value == selectBusValue).text}번 ${autoDispatchList[selectedCardIndex].opratIdx}회차 ${autoDispatchList[selectedCardIndex].caralcDtm} 출발)`
              : ""}
          </p>
        </Stack>
      </Dialog>
      {/**
       *   ______  __    __       ___      .__   __.   _______  _______    .______        ______    __    __  .___________. _______ 
 /      ||  |  |  |     /   \     |  \ |  |  /  _____||   ____|   |   _  \      /  __  \  |  |  |  | |           ||   ____|
|  ,----'|  |__|  |    /  ^  \    |   \|  | |  |  __  |  |__      |  |_)  |    |  |  |  | |  |  |  | `---|  |----`|  |__   
|  |     |   __   |   /  /_\  \   |  . `  | |  | |_ | |   __|     |      /     |  |  |  | |  |  |  |     |  |     |   __|  
|  `----.|  |  |  |  /  _____  \  |  |\   | |  |__| | |  |____    |  |\  \----.|  `--'  | |  `--'  |     |  |     |  |____ 
 \______||__|  |__| /__/     \__\ |__| \__|  \______| |_______|   | _| `._____| \______/   \______/      |__|     |_______|
                                                                                                                           
       */}
      <Dialog
        header={false}
        fullscreen
        show={changeRouteToggle}
        onHide={() => {
          setChangeRouteToggle(false);
          setChangeRouteSelectedIndexes([]);
        }}
        sumitButtonName='확인'
        onSumit={() => {
          if (!(changeRouteSelectedIndexes.length == 2)) {
            return Commons.Toast("error", "변경할 항목 두개를 선택해주세요.");
          } else {
            let _indexes = changeRouteSelectedIndexes;
            _indexes.sort((a, b) => a - b);
            setChangeRouteSelectedIndexes(_indexes);
            setChangeRouteToggle1(true);
          }
        }}
      >
        <Card>
          <Card.Body className='custom-table-grid-header'>
            <Stack direction='horizontal'>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>회차</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>출발시간</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>차량번호</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-64'>승무원</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>비고</div>
            </Stack>
          </Card.Body>
        </Card>
        <div className='custom-table-grid-datas3'>
          {autoDispatchList.map((item, index) => {
            // 선택된 카드인지 확인
            const isSelected = changeRouteSelectedIndexes.includes(index);
            const selectedCardColor = isSelected ? "custom-table-grid-selected" : "";

            // 카드 클릭 이벤트
            const SelectedCardEvnet = () => {
              if (isSelected) {
                // 이미 선택된 카드 클릭 시 선택 해제
                setChangeRouteSelectedIndexes((prev) => prev.filter((i) => i !== index));
              } else if (changeRouteSelectedIndexes.length < 2) {
                // 선택된 카드가 2개 미만일 때만 추가 선택 가능
                setChangeRouteSelectedIndexes((prev) => [...prev, index]);
              } else if (changeRouteSelectedIndexes.length == 2) {
                // 3개 이상 선택된 경우 첫 번째 항목 제거하고 새 항목 추가
                setChangeRouteSelectedIndexes((prev) => [...prev.slice(1), index]);
              }
            };

            return (
              <Card key={index} className={`${selectedCardColor}`} onClick={SelectedCardEvnet}>
                <Card.Body className='custom-table-grid-body'>
                  <Stack direction='horizontal'>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-48'>{item.opratIdx}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.caralcDtm}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.vhcleNo}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>{item.name}</div>
                    <div
                      className='p-2 custom-table-grid-body-text custom-table-text-width-48'
                      style={{
                        fontSize: item.remark.length > 2 ? "12px" : "1rem",
                      }}
                    >
                      {item.remark}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </Dialog>
      <Dialog
        title='회차 변경'
        show={changeRouteToggle1}
        onHide={() => setChangeRouteToggle1(false)}
        sumitButtonName='확인'
        onSumit={() => SaveLogic2(autoDispatchList[changeRouteSelectedIndexes[0]])}
      >
        <Stack direction='horizontal'>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "50%",
              fontWeight: "bold",
            }}
          >
            <span>{autoDispatchList.length > 0 && changeRouteSelectedIndexes.length > 0 ? autoDispatchList[changeRouteSelectedIndexes[0]].opratIdx : ""}</span>
            <span>회차</span>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "50%",
              fontWeight: "bold",
            }}
          >
            <span>{autoDispatchList.length > 0 && changeRouteSelectedIndexes.length > 1 ? autoDispatchList[changeRouteSelectedIndexes[1]].opratIdx : ""}</span>
            <span>회차</span>
          </div>
        </Stack>
      </Dialog>
      {/**
       *  _______ ___   ___  _______   ______  __    __  .___________. __    ______   .__   __. 
|   ____|\  \ /  / |   ____| /      ||  |  |  | |           ||  |  /  __  \  |  \ |  | 
|  |__    \  V  /  |  |__   |  ,----'|  |  |  | `---|  |----`|  | |  |  |  | |   \|  | 
|   __|    >   <   |   __|  |  |     |  |  |  |     |  |     |  | |  |  |  | |  . `  | 
|  |____  /  .  \  |  |____ |  `----.|  `--'  |     |  |     |  | |  `--'  | |  |\   | 
|_______|/__/ \__\ |_______| \______| \______/      |__|     |__|  \______/  |__| \__| 
                                                                                       
       */}
      <Dialog title='결행 처리하시겠습니까?' show={executionToggle} onHide={() => setExecutionToggle(false)} sumitButtonName='확인' onSumit={() => SaveLogic3(autoDispatchList[selectedCardIndex])}>
        <Radio
          items={[
            { value: "2", text: "금회" },
            { value: "0", text: "오전" },
            { value: "1", text: "오후" },
            { value: "3", text: "금일" },
          ]}
          value={executionRadio}
          onChange={(e) => setExecutionRadio(e)}
        />
      </Dialog>
      {/**
       *      ___        ______   ______  __   _______   _______ .__   __. .___________.
    /   \      /      | /      ||  | |       \ |   ____||  \ |  | |           |
   /  ^  \    |  ,----'|  ,----'|  | |  .--.  ||  |__   |   \|  | `---|  |----`
  /  /_\  \   |  |     |  |     |  | |  |  |  ||   __|  |  . `  |     |  |     
 /  _____  \  |  `----.|  `----.|  | |  '--'  ||  |____ |  |\   |     |  |     
/__/     \__\  \______| \______||__| |_______/ |_______||__| \__|     |__|     
                                                                               
       */}
      <Dialog header={false} fullscreen show={accidentToggle} onHide={() => AccidentClosed()} sumitButtonName='확인' onSumit={AccidentValidation}>
        <Card>
          <Card.Body className='custom-table-grid-header'>
            <Stack direction='horizontal'>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-48'>회차</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>출발시간</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-80'>차량번호</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-64'>승무원</div>
              <div className='p-2 custom-table-grid-header-text custom-table-text-width-64'>비고</div>
            </Stack>
          </Card.Body>
        </Card>
        <div className='custom-table-grid-datas mb-3' style={{ height: "62vh" }}>
          {accidentCarList.map((item, index) => {
            const isSelected = index === accidentInputs.selectedCardIndex;
            const selectedCardColor = isSelected ? "custom-table-grid-selected" : "";

            return (
              <Card
                key={index}
                className={`${selectedCardColor}`}
                onClick={() =>
                  setAccidentInputs({
                    ...accidentInputs,
                    selectedCardIndex: index,
                  })
                }
              >
                <Card.Body className='custom-table-grid-body'>
                  <Stack direction='horizontal'>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-48'>{item.opratIdx}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>{item.caralcDtm}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-80'>{item.vhcleNo}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>{item.name}</div>
                    <div className='p-2 custom-table-grid-body-text custom-table-text-width-64'>
                      {item.remark == "사고" ? (
                        <Button
                          size='sm'
                          title='사고'
                          onClick={() => {
                            setAccidentConfirmItem(item);
                            setAccidentToggle2(true);
                          }}
                        />
                      ) : item.remark == "고장" ? (
                        <Button
                          size='sm'
                          title='고장'
                          onClick={() => {
                            setAccidentConfirmItem(item);
                            setAccidentToggle2(true);
                          }}
                        />
                      ) : item.remark == "완료" ? (
                        "완료"
                      ) : item.remark == "1" ? (
                        ""
                      ) : (
                        item.remark
                      )}
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
        </div>
        <Stack>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%", fontWeight: "bold" }}>사고·고장</span>
            <Radio
              items={[
                { value: "A", text: "사고" },
                { value: "B", text: "고장" },
              ]}
              value={accidentInputs.accidentRadioValue}
              onChange={(e) =>
                setAccidentInputs({
                  ...accidentInputs,
                  accidentRadioValue: e,
                })
              }
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%", fontWeight: "bold" }}>정류장</span>
            <Dropdown
              variant='outline-primary'
              title={"정류장을 선택하세요."}
              items={accidentStationList}
              value={accidentInputs.stationValue}
              onChange={(e) =>
                setAccidentInputs({
                  ...accidentInputs,
                  stationValue: e,
                })
              }
            />
          </div>
        </Stack>
      </Dialog>
      <Dialog
        title={
          busList.length > 0 && busList.some((f) => f.value == selectBusValue) && accidentCarList.length > 0 && Number(accidentInputs.selectedCardIndex)
            ? `${busList.find((f) => f.value == selectBusValue).text}번 ${accidentCarList[accidentInputs.selectedCardIndex].opratIdx}회차`
            : ""
        }
        show={accidentToggle1}
        onHide={() => AccidentClosed(1)}
        sumitButtonName='확인'
        onSumit={SaveLogic4}
      >
        <Stack>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>대차 처리</span>
          </div>
          <Radio
            items={[
              { value: "Y", text: "예" },
              { value: "N", text: "아니오" },
            ]}
            value={accidentInputs.changedCarRadioValue}
            onChange={(e) =>
              setAccidentInputs({
                ...accidentInputs,
                changedCarRadioValue: e,
              })
            }
          />
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>배차 차량 변경</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>현재차량</span>
            <span>{accidentCarList.length > 0 && Number(accidentInputs.selectedCardIndex) ? accidentCarList[accidentInputs.selectedCardIndex].vhcleNo : ""}</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>대차</span>
            <Dropdown
              variant='outline-primary'
              title={"대차를 선택하세요."}
              disabled={accidentInputs.changedCarRadioValue == "N" ? true : false}
              items={accidentChangeCarList}
              value={accidentInputs.changedCarValue}
              onChange={(e) =>
                setAccidentInputs({
                  ...accidentInputs,
                  changedCarValue: e,
                })
              }
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>승무원 변경</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>현재</span>
            <span>{accidentCarList.length > 0 && Number(accidentInputs.selectedCardIndex) ? accidentCarList[accidentInputs.selectedCardIndex].name : ""}</span>
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>휴무자</span>
            <Dropdown
              variant='outline-primary'
              title={"휴무자를 선택하세요."}
              disabled={accidentInputs.changedCarRadioValue == "N" ? true : false}
              items={accidentHolidayPeopleList}
              value={accidentInputs.holidayPeopleValue}
              onChange={(e) => {
                setAccidentInputs({
                  ...accidentInputs,
                  holidayPeopleValue: e,
                  workPeopleValue: "",
                });
                if (accidentInputs.workPeopleValue) {
                  SelectLogic4();
                }
              }}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <span style={{ minWidth: "30%" }}>근무자</span>
            <Dropdown
              variant='outline-primary'
              title={"근무자를 선택하세요."}
              disabled={accidentInputs.changedCarRadioValue == "N" ? true : false}
              items={accidentWorkPeopleList}
              value={accidentInputs.workPeopleValue}
              onChange={(e) => {
                setAccidentInputs({
                  ...accidentInputs,
                  holidayPeopleValue: "",
                  workPeopleValue: e,
                });
                if (accidentInputs.holidayPeopleValue) {
                  SelectLogic3();
                }
              }}
            />
          </div>
          <div className='custom-dialog-inputs-container'>
            <div className='vertical-divider' />
            <span style={{ marginLeft: "4px", color: "#0d6efd" }}>적용 회차</span>
          </div>
          <Radio
            items={[
              {
                value: "2",
                text: "금회",
                disabled: accidentInputs.changedCarRadioValue == "N" ? true : false,
              },
              {
                value: "0",
                text: "오전",
                disabled: accidentInputs.changedCarRadioValue == "N" ? true : false,
              },
              {
                value: "1",
                text: "오후",
                disabled: accidentInputs.changedCarRadioValue == "N" ? true : false,
              },
              {
                value: "3",
                text: "금일",
                disabled: accidentInputs.changedCarRadioValue == "N" ? true : false,
              },
            ]}
            value={accidentInputs.episodeRadioValue}
            onChange={(e) =>
              setAccidentInputs({
                ...accidentInputs,
                episodeRadioValue: e,
              })
            }
          />
        </Stack>
      </Dialog>
      <Dialog title='승인 확인' show={accidentToggle2} onHide={() => setAccidentToggle2(false)} sumitButtonName='승인' onSumit={() => SaveLogic5(accidentConfirmItem)}>
        <span>승인 하시겠습니까?</span>
      </Dialog>
      <Dialog
        fullscreen
        title='약관 동의'
        show={termsToggle}
        onHide={() => {}}
        sumitButtonName='동의'
        onSumit={() => {
          if (termsChecked) {
            ApplyLogic();
          } else {
            Commons.Toast("error", "약관 동의를 체크해주세요.");
          }
        }}
        closeButton={false}
        footerChildren={<Checkbox className='terms-checkbox' title='개인정보 수집 &#183; 이용에 동의합니다.' value={termsChecked} onChange={(e) => setTermsChecked(e)} />}
      >
        <Terms />
      </Dialog>
      <Loading show={loading} />
    </React.Fragment>
  );
}

export default AdminAutoDispatch;
